export const availableCards = {
    Main: { id: "main", title: "maininfocontainer.header" },
    Internal: { id: "internal", title: "internalinfocontainer.header" },
    InyettDetails: { id: "inyettdetails", title: "inyettdetailscontainer.header" },
    CustomerConnections: { id: "customerConnections", title: "customerconnectionscontainer.header" },
    Vbproducts: { id: "vbproducts", title: "vbproductscontainer.header" },
    Subscriptions: { id: "subscriptions", title: "subscriptions.header" },
    Usage: { id: "usage", title: "vossusage.header" },
    Transactions: { id: "transactions", title: "transactionservices.header" },
    ThirdPartyProducts: { id: "thirdpartyproducts", title: "thirdpartyproductscontainer.thirdpartyproducts" },
    CustomerInteractions: { id: "customerInteractions", title: "customerinteractions.header" },
    AoCustomerInfo: { id: "aocustomerinfo", title: "aocustomerinformation.cardheader"},
    Migrations: { id: "migrations", title: "migrations.header" },
    TabsCard: { id: "tabscard", title: "tabscard", tabs: [] }
}